import { RequestStatus } from '@/types/requests';

export const WAITING_STATES = [RequestStatus.Idle, RequestStatus.Pending];
